// extracted by mini-css-extract-plugin
export default {"Message":"WildTableRow_Message__J1bfe"};